import { Injectable } from '@angular/core';
import { Profile } from 'src/app/proxy/account';

const TOKEN_KEY = 'auth-token';
const PERMISSION = 'user_permissions';
const REFRESHTOKEN_KEY = 'auth-refreshtoken';

@Injectable({
  providedIn: 'root',
})
export class TokenStorageService {
  constructor() {}

  signOut(): void {
    window.localStorage.clear();
  }

  public saveToken(token: string): void {
    window.localStorage.removeItem(TOKEN_KEY);
    window.localStorage.setItem(TOKEN_KEY, token);
  }

  public getToken(): string | null {
    return window.localStorage.getItem(TOKEN_KEY);
  }

  public savePermission(profile: Profile) {
    const jsonArray = JSON.stringify(profile.permissions);
    return window.localStorage.setItem(PERMISSION, jsonArray);
  }

  public getPermission(): string | null {
    return window.localStorage.getItem(PERMISSION);
  }

  public saveRefreshToken(token: string): void {
    window.localStorage.removeItem(REFRESHTOKEN_KEY);
    window.localStorage.setItem(REFRESHTOKEN_KEY, token);
  }

  public getRefreshToken(): string | null {
    return window.localStorage.getItem(REFRESHTOKEN_KEY);
  }
}